/* Bottom bar: highlight the section in view, and honour a #section link
   arriving from another page (the scroll-linked deck ignores native hash jumps). */
(function(){
  var tc = document.querySelector('meta[name="theme-color"]');
  if(tc) tc.setAttribute('content', '#ffffff');
  var bar = document.getElementById('mbar');
  var home = document.body.classList.contains('tpl-index');

  /* A #section link arriving from another page is handled by the
     homepage's link script (snippets/mobile-bar.liquid), as soon as the
     page is built rather than after everything has loaded. */

  /* Phone header: close the ☰ menu whenever the cart, a popup or a
     bottom-bar tab is used, so two menus are never open at once. */
  (function(){
    var burger = document.getElementById('burger'), mnav = document.getElementById('mnav');
    if(!burger || !mnav) return;
    document.addEventListener('click', function(e){
      if(!mnav.classList.contains('open')) return;
      var t = e.target.closest && e.target.closest('[data-open-bag], #mbar a, #mbar button');
      if(!t) return;
      mnav.classList.remove('open'); burger.classList.remove('x');
      burger.setAttribute('aria-expanded', 'false');
    }, true);
  })();

  /* Home tab on the homepage: back to the top instead of reloading. */
  (function(){
    var h = bar && bar.querySelector('[data-mb-home]');
    if(!h || !home) return;
    h.addEventListener('click', function(e){
      e.preventDefault();
      var x = document.querySelector('.panel.open [data-close]');
      if(x) x.click();
      window.scrollTo({top:0, behavior:'smooth'});
    });
  })();

  /* A section tab pressed while a popup is open: close the popup first,
     then go to the section (the page is scroll-locked while it is open). */
  if(bar){
    window.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('#mbar a[href*="#"]');
      if(!a || !document.body.classList.contains('panel-on')) return;
      var id = a.getAttribute('href').split('#')[1];
      var t = id && document.getElementById(id);
      if(!t) return;
      e.preventDefault(); e.stopPropagation();
      var x = document.querySelector('.panel.open [data-close]');
      if(x) x.click();
      setTimeout(function(){
        if(window.__goto) window.__goto(t); else t.scrollIntoView({behavior:'smooth'});
      }, 380);
    }, true);
  }

  /* Scroll progress line on the bottom bar. */
  (function(){
    var fill = bar && bar.querySelector('.mb-prog b');
    if(!fill) return;
    var tk = false;
    function upd(){
      tk = false;
      var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      fill.style.width = Math.min(100, Math.max(0, window.scrollY / h * 100)) + '%';
    }
    window.addEventListener('scroll', function(){ if(tk) return; tk = true; requestAnimationFrame(upd); }, {passive:true});
    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
  })();

  /* Desktop rail zipper: the pull rides the line right after the
     section you are in. */
  (function(){
    var lines = [].slice.call(document.querySelectorAll('#rail .r-line'));
    if(!lines.length) return;
    var tk = false;
    function upd(){
      tk = false;
      lines.forEach(function(l){
        var p = l.previousElementSibling;
        l.classList.toggle('cur', !!(p && p.classList.contains('now')));
      });
    }
    window.addEventListener('scroll', function(){ if(tk) return; tk = true; requestAnimationFrame(upd); }, {passive:true});
    window.addEventListener('load', upd);
    upd();
  })();

  if(!bar || !home) return;
  var items = [].slice.call(bar.querySelectorAll('[data-mb]'));
  var secs = [].slice.call(document.querySelectorAll('#page section[id]'));
  var ids = items.map(function(a){ return a.getAttribute('data-mb'); });
  var homeTab = bar.querySelector('[data-mb-home]');
  var tops = [];
  function measure(){
    tops = secs.map(function(s){ return window.__secTop ? window.__secTop(s) : s.offsetTop; });
  }
  var last = null;
  function frame(){
    var y = window.scrollY, cur = '';
    for(var i = 0; i < secs.length; i++) if(y >= tops[i] - window.innerHeight * 0.4) cur = secs[i].id;
    /* reviews sit inside the shop/offers run; map anything without its own tab to none */
    if(ids.indexOf(cur) === -1) cur = (y < window.innerHeight * 0.5) ? '__home' : '';
    if(cur === last) return;
    last = cur;
    items.forEach(function(a){ a.classList.toggle('act', a.getAttribute('data-mb') === cur); });
    if(homeTab) homeTab.classList.toggle('act', cur === '__home');
  }
  var q = false;
  window.addEventListener('scroll', function(){
    if(q) return; q = true;
    requestAnimationFrame(function(){ frame(); q = false; });
  }, {passive:true});
  var mt;
  window.addEventListener('resize', function(){ clearTimeout(mt); mt = setTimeout(function(){ measure(); frame(); }, 150); });
  window.addEventListener('load', function(){ measure(); frame(); setTimeout(function(){ measure(); frame(); }, 1200); });
  measure(); frame();
})();

/* ══════════ FIRST-SCROLL SMOOTHNESS ══════════
   1. The film is pulled down whole and played from memory, so every
      seek is instant on the very first scroll — no waiting on frames
      that have not arrived. The poster holds the frame until it lands.
   2. It is kept in the browser's Cache Storage for a few days, so a
      returning visitor gets it instantly with no download at all.
   3. On every other page (a product, a collection — where ads and
      Google usually land people) the film is fetched quietly in the
      background once the page is idle, so the homepage is ready before
      they ever click to it.
   4. Lazy images are fetched and decoded in the background once the
      page is idle, so the first scroll never waits on them. */
(function(){
  var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 250); };
  var conn = navigator.connection || {};
  var slow = !!(conn.saveData || /2g/.test(conn.effectiveType || ''));
  var CACHE = 'bustah-film-v1', DAYS = 3;

  function key(u){ return String(u).split('?')[0].replace(/^\/\//, location.protocol + '//'); }
  function fresh(r){
    var t = r && +r.headers.get('x-saved');
    return !!(t && Date.now() - t < DAYS * 864e5);
  }
  function fromCache(u){
    if(!window.caches) return Promise.resolve(null);
    return caches.open(CACHE).then(function(c){
      return c.match(key(u)).then(function(r){ return fresh(r) ? r.blob() : null; });
    }).catch(function(){ return null; });
  }
  function download(u){
    return fetch(u).then(function(r){
      if(!r.ok) throw new Error(r.status);
      return r.blob();
    }).then(function(b){
      if(window.caches) caches.open(CACHE).then(function(c){
        return c.put(key(u), new Response(b, { headers: {
          'content-type': b.type || 'video/mp4', 'x-saved': String(Date.now()) } }));
      }).catch(function(){});
      return b;
    });
  }
  function getFilm(u){ return fromCache(u).then(function(b){ return b || download(u); }); }

  var v = document.getElementById('bgv');
  var desc = window.HTMLMediaElement && Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'src');
  if(v && desc && desc.set && window.fetch && window.URL && URL.createObjectURL && !v.getAttribute('src')){
    var put = function(u){ desc.set.call(v, u); v.load(); };
    Object.defineProperty(v, 'src', {
      configurable: true,
      get: function(){ return desc.get.call(v); },
      set: function(u){
        delete v.src;                                  /* back to the native property */
        if(!u || /^blob:/.test(u)){ desc.set.call(v, u); return; }
        getFilm(u).then(function(b){ put(URL.createObjectURL(b)); })
                  .catch(function(){ put(u); });
      }
    });
    /* the film is started by the layout once the first screen is in, not here */
  }

  /* not the homepage: get the film ready for when they go there */
  if(!v && !slow && window.fetch && window.caches){
    var me = document.querySelector('script[src*="bustah-mbar.js"]');
    if(me){
      var dir = me.src.split('?')[0].replace(/bustah-mbar\.js$/, '');
      var film = dir + (window.matchMedia('(max-width: 760px)').matches ? 'film-mobile.mp4' : 'film.mp4');
      window.addEventListener('load', function(){
        setTimeout(function(){
          idle(function(){ fromCache(film).then(function(b){ if(!b) download(film).catch(function(){}); }); },
               {timeout: 4000});
        }, 2500);
      }, {once: true});
    }
  }

  function warm(){
    var imgs = [].slice.call(document.querySelectorAll('img[loading="lazy"]'));
    (function next(){
      var batch = imgs.splice(0, 6);
      if(!batch.length) return;
      batch.forEach(function(img){
        img.loading = 'eager';
        if(img.decode) img.decode().catch(function(){});
      });
      idle(next, {timeout: 1500});
    })();
  }
  if(document.readyState === 'complete') idle(warm, {timeout: 2000});
  else window.addEventListener('load', function(){ idle(warm, {timeout: 2000}); }, {once: true});
})();
